import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import {Tab, Tabs, List, ListItem, RaisedButton, FontIcon} from 'material-ui';

import { CheckBoxFieldF } from 'modules/forms/component';
import { FORM_MENSAJE } from 'modules/forms/formConstants';
import { Field, FormSection, change } from 'redux-form/immutable';

/*
Props:
diaViaje
*/
@connect((store, props) => ({
	viajes: store.getIn(['viajes', props.diaViaje]), //Acople, depende de viajes
}))
class CheckList extends React.Component {
	constructor(props) {
		super(props);
	}
	shouldComponentUpdate = nextProps => nextProps.viajes.size > 0
	selectAll = (select) => {
    if(this.props.viajes && this.props.viajes.size > 0){
      this.props.viajes.map( viaje => {
        this.props.dispatch(change(FORM_MENSAJE, `viajes.${viaje.get('id')}`, select));
      });
    }
  }
	render() {
		const {viajes, diaViaje} = this.props;
		return (
			<div>
				<FormSection name="viajes">
					{
						<Tabs>
							<Tab label={diaViaje == 'manana' ? 'Mañana' : 'Hoy'}>
								<RaisedButton
									onClick={() => this.selectAll(true)}
									icon={<FontIcon className="fa fa-check-square-o" />}
									secondary
									className="halfWidthComponent noPadding tinyButton"
								/>
								<RaisedButton
									onClick={() => this.selectAll(false)}
									icon={<FontIcon className="fa fa-square-o" />}
									secondary
									className="halfWidthComponent noPadding tinyButton"
								/>
								<List
									name={diaViaje}
									style={{ maxHeight: 500, overflow: 'auto' }}
								>
									{viajes && (
										viajes.map(item =>{
											const id = item.get('id');
											return(
												<ListItem
													key={id}
													className="noPadding textCenter"
														leftCheckbox={
															<Field
																name={id}
																component={CheckBoxFieldF}
																inputProps={{
																	label: moment(item.get('horario')).format('HH:mm')
																}}
															/>
														}
													/>);})
												) }
											</List>
										</Tab>
									</Tabs>
								}
							</FormSection>
						</div>
					);
				}
}

export default CheckList;



// WEBPACK FOOTER //
// src/modules/mensajes/components/checkListViajes.js